import { Textarea, TextareaProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

/*
 * Same translation as `MInput` (see its own header comment) — `Textarea`
 * has the identical `isDisabled`/`isReadOnly` no-op gap. Was a raw
 * `export { Textarea as MTextarea } from '@chakra-ui/react'` passthrough in
 * `chakra.tsx` until now.
 */
export interface MTextareaProps extends TextareaProps {
  isDisabled?: boolean;
  isReadOnly?: boolean;
}

const MTextarea = forwardRef<HTMLTextAreaElement, MTextareaProps>(
  ({ isDisabled, isReadOnly, disabled, readOnly, ...rest }, ref) => (
    <Textarea
      ref={ref}
      disabled={disabled ?? isDisabled}
      readOnly={readOnly ?? isReadOnly}
      {...rest}
    />
  ),
);

MTextarea.displayName = 'MTextarea';

export default MTextarea;
